// extracted by mini-css-extract-plugin
export default {"clickableButton":"getTableColumn_clickableButton__9L7Pe"};